var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style.overlay] = true, _obj[_vm.$style.transparent] = _vm.transparent, _obj )},[_c('img',{class:_vm.$style.loader,attrs:{"src":require("../../assets/img/progress-circle-success.svg")}}),_vm._v(" "),(_vm.message)?_c('p',{class:_vm.$style.message},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43a4e8a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading-overlay/loading-overlay.vue
// module id = ChrJ
// module chunks = 1